var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echart-dialog"},[_c('div',{staticClass:"mask"}),_c('div',{staticClass:"echart-dialog-content"},[_vm._t("header"),_c('i',{staticClass:"el-icon-error",on:{"click":_vm.closeDialog}}),_vm._t("xm-table"),_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }